<template>
  <div>
    <b-modal id="modal-input-hirarki" size="lg" centered title="Tambah Data Master Hirarki" header-bg-variant="primary" header-text-variant="light" @keydown.enter.prevent="simpan()">
      <b-form>
        <b-form-group label="Posisi Atasan" label-cols-md="3">
          <Multiselect
            v-model="$v.data.atasan.$model"
            :options="posisi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="id"
            label="namaPosisi"
            placeholder="-- Pilih Posisi Atasan --"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Posisi Bawahan" label-cols-md="3">
          <Multiselect
            v-model="$v.data.bawahan.$model"
            :options="posisi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="id"
            label="namaPosisi"
            placeholder="-- Pilih Posisi Bawahan --"
          ></Multiselect>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')"> Tutup </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalInput",
  props: ["posisi"],
  data() {
    return {
      data: {
        atasan: null,
        bawahan: null,
      },
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      atasan: {
        required,
      },
      bawahan: {
        required,
      },
      // masterDivisi: {
      //   required,
      // },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },

    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.data.atasan = vm.data.atasan.masterPosisiId;
      vm.data.bawahan = vm.data.bawahan.masterPosisiId;
      vm.$axios
        .post("levelAgreement/register", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN MASTER HIRARKI POSISI",
              showing: true,
            });
            this.data.namaPosisi = "";
            this.$bvModal.hide("modal-input-hirarki");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
